module.exports = __webpack_public_path__ + "static/media/23.38f908b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/23.jpg
// module id = 482
// module chunks = 0